import { lazy } from 'react';

export const HomePage = lazy(() => import('./HomePage'));
export const QuizPage = lazy(() => import('./QuizPage'));
export const PaymentPage = lazy(() => import('./PaymentPage'));
export const CreatePasswordPage = lazy(() => import('./CreatePasswordPage'));
export const DownloadAppPage = lazy(() => import('./DownloadAppPage'));
export const PolicyPage = lazy(() => import('./PolicyPage'));
export const ContactPage = lazy(() => import('./ContactPage'));
export const LoginPage = lazy(() => import('./LoginPage'));
export const ManageSubscriptionPage = lazy(
  () => import('./ManageSubscriptionPage'),
);
export const NewPasswordPage = lazy(() => import('./NewPasswordPage'));
export const ProfilePage = lazy(() => import('./ProfilePage'));
export const ResetPasswordPage = lazy(() => import('./ResetPasswordPage'));
export const TermsPage = lazy(() => import('./TermsPage'));
export const Page404 = lazy(() => import('./Page404'));
export const CancelSubscriptionPage = lazy(
  () => import('./CancelSubscriptionPage'),
);
export const OfferSubscriptionPage = lazy(
  () => import('./OfferSubscriptionPage'),
);
export const CancelSubscriptionReminderPage = lazy(
  () => import('./CancelSubscriptionReminderPage'),
);
export const PauseSubscriptionPage = lazy(
  () => import('./PauseSubscriptionPage'),
);
export const ProfileFastingPlansPage = lazy(
  () => import('./ProfileFastingPlansPage'),
);
export const ProfileOneFreeMonthPage = lazy(
  () => import('./ProfileOneFreeMonthPage'),
);
export const ProfileLoginInApp = lazy(() => import('./ProfileLoginInApp'));
export const AppLoginPage = lazy(() => import('./AppLoginPage'));
export const CancelAfterFreeMonthPage = lazy(
  () => import('./CancelAfterFreeMonthPage'),
);
